// Loads the Google Maps JS API (maps + places) once per page. Safe next to the
// older per-controller loaders (wizard, places search): if their script tag is
// already on the page it waits for it instead of adding a second copy.
let googleMapsPromise = null

export function loadGoogleMaps(win = window) {
  if (win.google?.maps?.places) return Promise.resolve()
  if (googleMapsPromise) return googleMapsPromise

  const doc = win.document
  const pending = doc.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')
  if (pending) {
    googleMapsPromise = new Promise((resolve, reject) => {
      let tries = 0
      const timer = win.setInterval(() => {
        if (win.google?.maps?.places) { win.clearInterval(timer); resolve() }
        else if (++tries > 150) { win.clearInterval(timer); googleMapsPromise = null; reject("Google Maps did not load") }
      }, 100)
    })
    return googleMapsPromise
  }

  const apiKey = doc.querySelector('meta[name="google-maps-api-key"]')?.content
  if (!apiKey) return Promise.reject("No Google Maps API key")

  googleMapsPromise = new Promise((resolve, reject) => {
    win._initSharedGoogleMaps = () => { delete win._initSharedGoogleMaps; resolve() }
    const script = doc.createElement("script")
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=_initSharedGoogleMaps`
    script.async = true
    script.onerror = () => { googleMapsPromise = null; reject("Failed to load Google Maps") }
    doc.head.appendChild(script)
  })
  return googleMapsPromise
}

// Google address parts → the fields our forms keep (street, city, state, zip).
export function addressFromComponents(components, formatted = "") {
  if (!components) return null
  const get = (type) => components.find((c) => c.types.includes(type))
  const street = [get("street_number")?.long_name, get("route")?.long_name].filter(Boolean).join(" ")
  return {
    address: street || formatted.split(",")[0] || "",
    city: get("locality")?.long_name || get("postal_town")?.long_name ||
      get("sublocality")?.long_name || get("administrative_area_level_2")?.long_name || "",
    state: get("administrative_area_level_1")?.short_name || "",
    zipcode: get("postal_code")?.long_name || ""
  }
}
